export var UserStateEnum;
(function (UserStateEnum) {
    UserStateEnum["ACTIVE"] = "ACTIVE";
    UserStateEnum["BLOCKED"] = "BLOCKED";
    UserStateEnum["SUSPENDED"] = "SUSPENDED";
    UserStateEnum["DELETED"] = "DELETED";
    UserStateEnum["MERGED"] = "MERGED";
})(UserStateEnum || (UserStateEnum = {}));
//# sourceMappingURL=user-state.enum.js.map